module.exports = __webpack_public_path__ + "img/slide4_mobile.b7f4d139.jpg";